import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
export const JOB_UPDATE_EVENT_NAME = 'JobUpdate';
function patchRelationshipPdf(task, payload, now) {
    if (payload.status === 'ready') {
        return _object_spread_props(_object_spread({}, task), {
            status: 'ready',
            progress: 100,
            downloadUrl: payload.downloadUrl,
            fileName: payload.fileName,
            updatedAt: now
        });
    }
    if (payload.status === 'failed') {
        return _object_spread_props(_object_spread({}, task), {
            status: 'failed',
            progress: 100,
            error: payload.error,
            updatedAt: now
        });
    }
    return _object_spread_props(_object_spread({}, task), {
        status: payload.status,
        progress: payload.progress
    });
}
function patchBulkRun(task, payload, now) {
    var _payload_jobName;
    return _object_spread_props(_object_spread({}, task), {
        status: payload.status,
        progress: payload.progress,
        jobName: (_payload_jobName = payload.jobName) !== null && _payload_jobName !== void 0 ? _payload_jobName : task.jobName,
        succeeded: payload.succeeded,
        failed: payload.failed,
        total: payload.total,
        updatedAt: now
    });
}
export function applyJobPatch(task, payload, now) {
    switch(task.kind){
        case 'relationshipPdf':
            if (payload.kind !== 'relationshipPdf') return task;
            return patchRelationshipPdf(task, payload, now);
        case 'bulkSendProposals':
            if (payload.kind !== 'bulkSendProposals') return task;
            return patchBulkRun(task, payload, now);
        case 'bulkCreateDrafts':
            if (payload.kind !== 'bulkCreateDrafts') return task;
            return patchBulkRun(task, payload, now);
        default:
            {
                const _exhaustive = task;
                return _exhaustive;
            }
    }
}
